import { useTranslation } from "react-i18next";
import type { RecordingVideoFileGroup } from "./recordingVideoFileGroups";

export default function RecordingVideoFileGroupHeader({
  group,
}: {
  group: RecordingVideoFileGroup | null;
}) {
  const { t } = useTranslation("pages");

  return (
    <div className="-mx-3 -mt-3 mb-3 flex flex-wrap items-baseline justify-between gap-2 rounded-t-lg border-b border-secondary-200 bg-secondary-50 px-3 py-2.5 sm:-mx-4 sm:-mt-4 sm:mb-4 sm:px-4">
      <h5 className="font-semibold text-secondary-900">
        {group
          ? t("sessions.detail.videoFiles.recordingLabel", {
              index: group.index + 1,
            })
          : t("sessions.detail.videoFiles.unassignedFiles")}
      </h5>
      {group && (
        <span className="text-xs text-secondary-500">
          {t("sessions.detail.videoFiles.chapterCount", {
            count: group.recording.chapters.length,
          })}
        </span>
      )}
    </div>
  );
}
